import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

/** [icoonnaam, zoektekst] — gegenereerd door `npm run generate-fa-index`. */
export type HdFaIconIndexEntry = readonly [string, string];

/**
 * Lazy loader voor de slanke Font Awesome-naamindex (assets/fa-icon-index.json).
 * Eén fetch per sessie; de picker vraagt hem pas op wanneer hij opent.
 */
@Injectable({ providedIn: 'root' })
export class HdFaIconIndexService {
  private readonly http = inject(HttpClient);
  private cache?: Promise<readonly HdFaIconIndexEntry[]>;

  load(): Promise<readonly HdFaIconIndexEntry[]> {
    this.cache ??= firstValueFrom(this.http.get<HdFaIconIndexEntry[]>('assets/fa-icon-index.json'))
      .catch(error => {
        // Mislukte fetch niet cachen: een volgende poging mag het opnieuw proberen.
        this.cache = undefined;
        throw error;
      });
    return this.cache;
  }
}
